import React from 'react'
import { ForwardIcon } from '../../icons/Icons'
import PropTypes from 'prop-types'
import classes from './styles.module.scss'
import classNames from 'classnames'

const MenuItem = ({ item, width, openIframe, action }) => {
  if (item.type === 'web_url' && !item.enableMessengerExtensions) {
    return (
      <a
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames(classes.item, 'menu-item-button')}>
        {item.title}
      </a>
    )
  }
  if (item.type === 'web_url' && item.enableMessengerExtensions) {
    return (
      <div
        className={classNames(classes.item, 'menu-item-button')}
        onClick={openIframe.bind(null, item.url)}
        style={{ width }}>
        <span>{item.title}</span>
      </div>
    )
  }
  return (
    <div
      className={classNames(classes.item, 'menu-item-button')}
      onClick={action}
      style={{ width }}>
      <span>{item.title}</span>
      {item.type === 'nested' && (
        <div className={classes.icon}>
          <ForwardIcon />
        </div>
      )}
    </div>
  )
}

MenuItem.propTypes = {
  item: PropTypes.object.isRequired,
  action: PropTypes.func,
}

export default MenuItem
